import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "../../assets/styles/loan.module.css";
import AppIcons from "../../utils/appIcons";
import { loanEligibilityOrDocuments } from "../../utils/businessLoanUtil";
import { isMobile } from "../../utils/responsiveUtil";

function Eligibility() {
  return (
    <Box position={"relative"} pt="70px" pb={"120px"}>
      {!isMobile && renderIcons()}

      <Box className={`container`}>
        {!isMobile && (
          <img
            src={AppIcons.imgEligibilityBadge}
            className={styles.eligibilityBadge}
          />
        )}
        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          gap={isMobile ? 4 : 0}
          justifyContent={"center"}
          style={{ transform: isMobile ? "scale(1)" : "scale(0.92)" }}
        >
          {loanEligibilityOrDocuments.map((option, index) => {
            return (
              <OrangeDottedBox
                key={index}
                title={option.title}
                isRight={option.isRight}
                features={option.features}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

function OrangeDottedBox({ title, isRight, features }) {
  return (
    <Box
      width={isMobile ? "100%" : "50%"}
      className={styles.orangeDottedBox}
      alignItems={isRight && !isMobile ? "flex-end" : "flex-start"}
    >
      <Typography
        mb={isMobile ? 0 : 2}
        className={styles.orangeDottedBoxTitle}
        style={{ direction: isRight && !isMobile ? "rtl" : "ltr" }}
        borderRadius={
          isRight && !isMobile ? "16px 0px 0px 16px" : "0px 16px 16px 0px"
        }
      >
        {title}
      </Typography>
      <ul
        className={styles.listWrapper}
        style={{ direction: isRight && !isMobile ? "rtl" : "ltr" }}
      >
        {features.map((feature, index) => {
          return <li key={index}>{feature}</li>;
        })}
      </ul>
    </Box>
  );
}

function renderIcons() {
  return (
    <>
      <img src={AppIcons.icDonut} width={53} className={styles.donutIcon} />
      <img
        src={AppIcons.imgOrangeStar}
        width={49}
        className={styles.eligibilityStarIcon}
      />
      <img
        src={AppIcons.icGreyCircle}
        width={55}
        className={styles.eligibilityGreyCircle}
      />
      <img
        src={AppIcons.imgOrangeStar}
        width={32}
        className={styles.eligibilityBottomStarIcon}
      />
      <img
        src={AppIcons.imgHalfPeachVector}
        width={272}
        className={styles.peachVector}
      />
      <img
        src={AppIcons.imgHalfYellowVector}
        className={styles.eligibilityYellowVector}
      />
    </>
  );
}
export default Eligibility;
